import {Link, Route} from 'react-router-dom';
import React from 'react';
import AuthMiddleware from '../middleware/AuthMiddleware';
import CreateUserRole from "../../modules/user/CreateUserRole";
import {useSelector} from "react-redux";
import ManageUserRole from "../../modules/user/ManageUserRole";
import EditUserRole from "../../modules/user/EditUserRole";
import CreateUser from "../../modules/user/CreateUser";
import ManageUsers from "../../modules/user/ManageUsers";
import EditUser from "../../modules/user/EditUser";
import {checkPermission} from "./RouteValidator";

const GenerateUserModuleRoutes = () => {
    const company = useSelector((state: any) => state.company);
    const auth = useSelector((state: any) => state.auth);

    const routes: any = [];

    if (checkPermission(auth, company, '/roles/add')) {
        routes.push(
            <Route path={'/roles/add'} element={
                <AuthMiddleware children={<CreateUserRole/>}/>
            }/>
        );
    }
    if (checkPermission(auth, company, '/roles')) {
        routes.push(
            <Route path={'/roles'} element={
                <AuthMiddleware children={<ManageUserRole/>}/>
            }/>
        );
    }
    if (checkPermission(auth, company, '/roles/details/id')) {
        routes.push(
            <Route path={'/roles/details/:id'} element={
                <AuthMiddleware children={<EditUserRole/>}/>
            }/>
        );
    }

    if (checkPermission(auth, company, '/users/add')) {
        routes.push(
            <Route path={'/users/add'} element={
                <AuthMiddleware children={<CreateUser/>}/>
            }/>
        );
    }

    if (checkPermission(auth, company, '/users')) {
        routes.push(
            <Route path={'/users'} element={
                <AuthMiddleware children={<ManageUsers/>}/>
            }/>
        );
    }

    if (checkPermission(auth, company, '/users/details/id')) {
        routes.push(
            <Route path={'/users/details/:id'} element={
                <AuthMiddleware children={<EditUser/>}/>
            }/>
        );
    }


    return routes;
}

export default GenerateUserModuleRoutes;
